import { atom } from "jotai";
import { OTPCountDownInitialState } from "./type";

const countDownInitialState: OTPCountDownInitialState = {
  waitTime: Date.now() + 1000 * 120,
  expireTime: Date.now() + 1000 * 600,
  limitTime: Date.now() + 1000 * 600,
};

export const countDownAtom = atom(countDownInitialState);

export const resetTimerPredicate = (
  value: OTPCountDownInitialState
): OTPCountDownInitialState => {
  return {
    ...value,
    waitTime: Date.now() + 1000 * 120,
    expireTime: Date.now() + 1000 * 600,
    limitTime: Date.now() + 1000 * 600,
  };
};
export const updateWaitTimePredicate = (
  value: OTPCountDownInitialState
): OTPCountDownInitialState => {
  return { ...value, waitTime: Date.now() + 1000 * 120 };
};

export const updateExpireTimePredicate = (
  value: OTPCountDownInitialState
): OTPCountDownInitialState => {
  return { ...value, expireTime: Date.now() + 1000 * 600 };
};
